import React from "react";
import SidebarComponent from "../sideMenu";
import HeaderComponent from "../navigationBar";

const DeliveriesComponent = () => {
    return (
        <>
            <HeaderComponent/>
            <SidebarComponent/>
            Dashboard Component
        </>
    )
}

export default DeliveriesComponent;